import { Pipe, PipeTransform } from '@angular/core';
import { APIServiceProviderService } from '../services/APIServices/APIServiceProviderService/APIServiceProviderService';
import { CommonService } from '../services/common.service';

@Pipe({ name: 'currencyFormatter' })

export class CurrencyFormatterPipe implements PipeTransform {
    constructor(private apiserviceProvider: APIServiceProviderService, public commonService : CommonService) {

    }
    transform(str: any, args: any): any {
        const visibleDigitLength = this.commonService.currencyvisibleLength?.toString() ? 
        this.commonService.currencyvisibleLength : 4;
        if ((str != null && str !== '' && str != undefined && this.commonService.isFocusOut && /^[a-z_A-Z]+$/.test(str) != true)) {
            str = Number(str.toString().replace(/,/g,'')).toFixed(visibleDigitLength).toString();
        }
        return str;
    }
}
